import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { Point } from 'pixi.js';
import { IGameState } from 'State/Game/IGameState';
import { isPayer } from 'Utility/Helpers/IAP/isPayer';
import { ISundayOfferData } from 'Utility/Helpers/IAP/ISundayOfferData';
import { PopupOffersOfType, PopupOfferType } from 'Utility/Helpers/IAP/PopupOffers';
import { ProductId } from 'Utility/Product';

const isNotPayer = (state: IGameState) => {
    return !isPayer(state);
};

export const SUNDAY_OFFERS: Record<keyof PopupOffersOfType<PopupOfferType.SUNDAY_OFFER>, ISundayOfferData> = {
    [ProductId.SUNDAY_OFFER_V2_44_99]: {
        productId: ProductId.SUNDAY_OFFER_V2_44_99,
        dragonbonesPath: `${DRAGONBONES_PATH}/SundayOffer_v2/`,
        dragonbonesName: 'sunday_offer_2',
        animationName: 'animtion0',
        armaturePosition: new Point(426, 580),
        layoutFileName: 'SundayOffer2Layout',
        buttonCacheKey: 'sunday_sale_2_icon',
        condition: isPayer,
    },
    [ProductId.SUNDAY_OFFER_V2]: {
        productId: ProductId.SUNDAY_OFFER_V2,
        dragonbonesPath: `${DRAGONBONES_PATH}/SundayOffer_v2/`,
        dragonbonesName: 'limited_offer_2_export',
        armaturePosition: new Point(426, 580),
        layoutFileName: 'SundayOfferLayout',
        buttonCacheKey: 'sunday_sale_icon',
        condition: isPayer,
    },
    [ProductId.SUNDAY_OFFER_3_9_99]: {
        productId: ProductId.SUNDAY_OFFER_3_9_99,
        dragonbonesPath: `${DRAGONBONES_PATH}/SundayOffer_NonPayers/`,
        dragonbonesName: 'sunday_offer_3',
        animationName: 'sitting',
        armaturePosition: new Point(426, 580),
        layoutFileName: 'SundayOfferLayout3NonPayers',
        buttonCacheKey: 'sunday_sale_icon',
        condition: isNotPayer,
    },
};
